export class WorkRegionModel {
  WorkRegionID: string;
  RegionName: string;
  enumCountryID: string;

  constructor(workRegionID: string, regionName: string, enumCountryID: string ='00000007-1000-0000-0000-000000000001') {
    this.WorkRegionID = workRegionID;
    this.RegionName = regionName;
    this.enumCountryID = enumCountryID;
  }
}
